"use client";
import { usePublicLocale } from "../../public-locale";
import { industryNavigation, navigationCopy } from "../industries/navigation";
import { IndustryIcon } from "../industries/IndustryIcon";
import Link from "./MarketingLink";
import { MarketingIcon } from "./MarketingIcon";
import { OptrixisMark } from "./OptrixisMark";

export default function IndustriesMenu({ id, mobile = false }: { id: string; mobile?: boolean }) {
  const locale = usePublicLocale();
  return (
    <div id={id} className={mobile ? "industry-mobile-panel" : "industry-mega-menu"}>
      {!mobile && (
        <div className="industry-menu-intro">
          <strong>{navigationCopy.title[locale]}</strong>
          <span>{navigationCopy.subtitle[locale]}</span>
          <span className="industry-menu-mark" dir="ltr" aria-hidden="true">
            <OptrixisMark />
          </span>
        </div>
      )}
      <ul className="industry-menu-grid">
        {industryNavigation.map((industry) => (
          <li key={industry.id}>
            <Link href={`/industries/${industry.id}`} className="industry-menu-link">
              <span className="industry-menu-icon">
                <IndustryIcon id={industry.id} />
              </span>
              <span>
                <strong>{industry.name[locale]}</strong>
                <small>{industry.summary[locale]}</small>
              </span>
              <MarketingIcon name="arrow" className="industry-menu-arrow" />
            </Link>
          </li>
        ))}
      </ul>
      <Link href="/industries" className="industry-menu-all">
        {navigationCopy.all[locale]}
        <MarketingIcon name="arrow" className="industry-menu-arrow" />
      </Link>
    </div>
  );
}
